import React from 'react';
import { FilterItemVo, ListCheckboxRow } from '../ListCheckboxRow';
import { useRefinementFacetPriceBuckets } from './RefinementFacetPriceBuckets.controller';
import { StyledContainer } from './RefinementFacetPriceBuckets.styles';
import { useTranslation } from '@shared/core';
import { getTitleFromBucketCode } from '../../../../utils/priceRange';

export type RefinementFacetPriceBucketsArgs = {
  options: FilterItemVo[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const RefinementFacetPriceBuckets: React.FC<RefinementFacetPriceBucketsArgs> = args => {
  const { currentOptions, handleSelectedChange } = useRefinementFacetPriceBuckets(args);
  const { t } = useTranslation('catalogRegistry');
  const refinementsPanel = t('refinementsPanel');

  return (
    <StyledContainer>
      {currentOptions.map(item => {
        const title = getTitleFromBucketCode(item.value.code, refinementsPanel);
        const itemUpdated = { ...item, value: { ...item.value, title } };
        return (
          <ListCheckboxRow
            key={item.value.code}
            item={itemUpdated}
            handleSelectedChange={handleSelectedChange}
          />
        );
      })}
    </StyledContainer>
  );
};

export { RefinementFacetPriceBuckets };
